import styled, {keyframes} from 'styled-components';

import List from './List';

const enter = keyframes`
  from {
    transform: scale(0.9);
    opacity: 0.65;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const FloatingList = styled(List).attrs({'data-floating-list': ''})`
  box-shadow: var(--theme-big-shadow);
  border-radius: var(--theme-radius);

  animation-fill-mode: both !important;

  border-radius: var(--theme-radius);

  &[data-radius='square'] {
    border-radius: 0;
  }
  &[data-radius='small'] {
    border-radius: var(--theme-radius-sm);
  }
  &[data-radius='normal'] {
    border-radius: var(--theme-radius);
  }

  --icon-default-size: 1.5rem;
  --btn-default-size: 2.125rem;
  --input-default-size: 2.125rem;
  --avatar-default-size: 2rem;
  --checkbox-default-size: 1.25rem;
  --radio-default-size: 1.25rem;

  &.entering {
    animation: ${enter} 150ms var(--theme-animation-movement-curve);
  }
  &.exiting {
    animation: ${enter} 100ms var(--theme-animation-movement-curve) reverse;
  }
`;

export default FloatingList;
